import { FC } from 'react'

import { Toaster } from 'sonner'

import { useIsMounted } from '@trustycars/genie-ui/hooks'
import { Portal } from '@trustycars/genie-ui/components'

import { RouterProvider } from '$contexts/Router'
import useBootstrap from '$actions/useBootstrap'

import { lazyComponent as lazy } from '$app/utilities'
import Routing from '$app/Routing'

import { toastTitle } from '$styles/atoms.css'

const Sprite = lazy(() => import('@trustycars/genie-ui/icons/Sprites'))
const BrandIconSprites = lazy(() => import('$icons/BrandIcon/Sprites'))
const EnvIconSprites = lazy(() => import('$icons/EnvIcon/Sprites'))
const DeviceIconSprites = lazy(() => import('$icons/DeviceIcon/Sprites'))
const ExtraIconSprites = lazy(() => import('$icons/ExtraIcon/Sprites'))

const Contents: FC = () => {
  const isMounted = useIsMounted()

  useBootstrap()

  if (!isMounted) return null

  return (
    <>
      <Sprite />
      <BrandIconSprites />
      <EnvIconSprites />
      <DeviceIconSprites />
      <ExtraIconSprites />

      <Routing />

      <Portal>
        <Toaster
          richColors
          theme="system"
          position="top-center"
          toastOptions={{ classNames: { title: toastTitle } }}
        />
      </Portal>
    </>
  )
}

const App: FC = () => (
  <RouterProvider>
    <Contents />
  </RouterProvider>
)

export default App
